import React, { useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaStar, FaUserAlt, FaBed, FaExpand, FaCheckCircle, FaArrowLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { rooms } from '../data/hotelData';
import BookingForm from '../components/BookingForm/BookingForm';
import './RoomDetails.css';

export default function RoomDetails() {
  const { slug } = useParams();
  const room = rooms.find(r => r.name.toLowerCase().replace(/\s+/g, '-') === slug);
  const [activeImg, setActiveImg] = useState(0);

  if (!room) return <Navigate to="/rooms" replace />;

  const relatedRooms = rooms.filter(r => r.id !== room.id).slice(0, 3);

  return (
    <main>
      <div className="room-detail-hero">
        <div className="room-detail-gallery">
          <div className="gallery-main">
            <motion.img
              key={activeImg}
              src={room.images[activeImg]}
              alt={room.name}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
            />
            {room.images.length > 1 && (
              <>
                <button className="gallery-nav prev" onClick={() => setActiveImg(i => (i - 1 + room.images.length) % room.images.length)}>
                  <FaChevronLeft />
                </button>
                <button className="gallery-nav next" onClick={() => setActiveImg(i => (i + 1) % room.images.length)}>
                  <FaChevronRight />
                </button>
              </>
            )}
          </div>
          <div className="gallery-thumbs">
            {room.images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt=""
                className={i === activeImg ? 'active' : ''}
                onClick={() => setActiveImg(i)}
              />
            ))}
          </div>
        </div>
      </div>

      <section className="section room-detail-content">
        <div className="container">
          <div className="room-detail-grid">
            <div className="room-detail-main">
              <Link to="/rooms" className="back-link"><FaArrowLeft /> Back to Rooms</Link>

              <div className="room-detail-header">
                <div>
                  <span className="room-cat-badge">{room.category}</span>
                  <h1 className="room-detail-name">{room.name}</h1>
                  <div className="room-detail-rating">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} style={{ color: i < Math.floor(room.rating) ? '#fbbf24' : '#e0e0e0' }} />
                    ))}
                    <strong>{room.rating}</strong>
                    <span>({room.reviews} reviews)</span>
                  </div>
                </div>
                <div className="room-detail-price">
                  <span>from</span>
                  <strong>${room.price}</strong>
                  <span>/night</span>
                </div>
              </div>

              <div className="room-detail-stats">
                <div className="stat-item"><FaExpand /><span>{room.size} m²</span><label>Room Size</label></div>
                <div className="stat-item"><FaUserAlt /><span>{room.capacity}</span><label>Guests</label></div>
                <div className="stat-item"><FaBed /><span>{room.beds}</span><label>Bed Type</label></div>
                <div className="stat-item"><span>👁</span><span>{room.view}</span><label>View</label></div>
              </div>

              <div className="room-detail-desc">
                <h3>About This Room</h3>
                <p>{room.description}</p>
              </div>

              <div className="room-detail-amenities">
                <h3>Room Amenities</h3>
                <div className="amenities-list">
                  {room.amenities.map(a => (
                    <div key={a} className="amenity-row">
                      <FaCheckCircle className="check-icon" /> {a}
                    </div>
                  ))}
                </div>
              </div>

              <div className="room-detail-policies">
                <h3>Policies</h3>
                <ul>
                  <li>Check-in: 3:00 PM · Check-out: 12:00 PM</li>
                  <li>Free cancellation up to 48 hours before arrival</li>
                  <li>Pets allowed on request (fees apply)</li>
                  <li>Smoking is not permitted in this room</li>
                </ul>
              </div>
            </div>

            <div className="room-detail-sidebar">
              <div className="booking-sidebar-card">
                <h3>Reserve This Room</h3>
                <BookingForm compact />
                <div className="booking-guarantee">
                  <FaCheckCircle style={{ color: 'var(--primary)' }} />
                  <span>Best rate guaranteed · No booking fees</span>
                </div>
              </div>
            </div>
          </div>

          <div className="related-rooms">
            <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '36px' }}>You May Also Like</h2>
            <div className="related-rooms-grid">
              {relatedRooms.map(r => (
                <Link key={r.id} to={`/rooms/${r.name.toLowerCase().replace(/\s+/g, '-')}`} className="related-room-card">
                  <img src={r.image} alt={r.name} />
                  <div className="related-room-info">
                    <h4>{r.name}</h4>
                    <p>from <strong>${r.price}</strong>/night</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
